// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__392AC","title":"ClientInsurance_title__epo9N","itemText":"ClientInsurance_itemText__7LNuG"};